<template>
  <div class="pack-box" :class="`pack-box${copyright.entrantsType}`">
    <div class="gouBack" @click="goBack">
      <i class="iconfont el-icon-arrow-left" />
      {{ "返回资料包列表" }}
    </div>
    <div class="bigBox">
      <div v-for="(item, index) in packageList" :key="index" class="boxItem">
        <div class="contentItem">
          <div v-if="!IsPurchase" class="seeBtn" />
          <div class="sourceImg">
            <img v-if="item.filetype == 'excel'" class="imgItem"
              src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/study/dataXls.png">
            <img v-else-if="item.filetype == 'word'" class="imgItem"
              src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/study/dataDoc.png">
            <img v-else-if="item.filetype == 'pdf'" class="imgItem"
              src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/study/dataPdf.png">
            <img v-else-if="item.filetype == 'ppt'" class="imgItem"
              src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/study/dataPpt.png">
            <img v-else class="imgItem" src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/study/dataFile.png">
          </div>
          <div class="contentBox">
            <div class="contentTitle">{{ item.materialName }}</div>
            <!-- <div class="contentTips">{{ item.size }}</div> -->
          </div>
        </div>
        <div v-if="!IsPurchase && item.seeNum && item.seeNum > 0 && userInfo" class="btnItem" @click="goTry(item)">
          免费试看
        </div>
        <div class="dis_flex">
          <div v-if="IsPurchase && item.knowledgePoints" class="kowledge_Btn" @click="openKowledge(item)">
            知识点
          </div>
          <div v-if="IsPurchase" class="dowBtn" @click="dowInfo(item)">
            下载
          </div>
        </div>
      </div>
    </div> 
    <div v-if="!IsPurchase " class="buyBox">
      <div class="priceBox">
        <div class="buyBtnBox">
          <div class="price">
            <span class="symbol">￥</span>
            <span class="num">{{ price }}</span>
          </div>
          <div class="buyBtn" @click="goOrder">立即购买</div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="kowledgePointsVisible" width="50%" :before-close="kowledgePointsClose"
      :show-close="false">
      <div class="kowledgePoints_wrap">
        <kowledgePoints ref="kowledgePoints" type="4" />
        <div class="determine_btn" @click="kowledgePointsClose">确定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import { getInfo, getToken } from '@/api/cookies'
// import { OrderClient } from '@/api/orderClient'
// const orderClient = new OrderClient()

import { getDomain } from '@/api/cookies'
import kowledgePoints from '@/components/kowledgePoints.vue'
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
  components: {
    kowledgePoints
  },
  data() {
    return {
      copyright: {},
      id: null, // 资料包ID
      title: null, // 资料包名称
      schoolId: null, // 大类ID
      userInfo: null,
      packageList: null, // 资料列表
      IsPurchase: false, // 1 未购买 0 已购买
      price: null,
      kowledgePointsVisible: false,
      university: ''
    }
  },
  async created() {
    this.copyright = getDomain()

    this.id = this.$route.query.id
    this.userInfo = getInfo()
 if (this.copyright.eId == process.env.VUE_APP_university) {
      this.university = 1
    }
    this.getPackageDetails()
    homeClient.whetherBuy({
      commodityId: this.id,
      commodityTypeCode: 4, 
    }).then((res) => {
      if (res.code == 0) {
        this.IsPurchase = res.data == 1 ? true : false
      }
    })

    this.title = this.$route.query.title
    // this.IsPurchase = this.$route.query.IsPurchase
    this.price = this.$route.query.num
  },
  methods: {

    goBack() {
      this.$router.go(-1)
    },
    /* 资料详情 */
    getPackageDetails() {
      const that = this
      // if (this.userInfo) {
      homeClient
        .getPackageInfoById({ id: this.id, })
        .then((res) => {

          this.packageList = res.data.packageItemList
        })
      // }
    },
    /* 查看 */
    goTry(item) {
      this.$router.push({
        path: '/VIP/sourcePage',
        query: {
          seeNum: item.seeNum,
          uploadMaterial: item.uploadMaterial,
          id: this.id,
          title: this.title,
          schoolId: this.schoolId,
          type: 2,
          IsPurchase: this.IsPurchase,
        }
      })
    },
    goOrder() {
      const token = getToken()
      if (token) {
        let arr = [];
        let obj = {
          commodityTypeCode: 4,
          commodityId: this.id,
          discount: 0,
        };
        arr.push(obj);
        homeClient
          .addPayOrders(arr, undefined)
          .then((res) => {
            if (res.code == 0) {
              this.$router.push(`/orders/${res.data.orderNum}`)
            } else {
              this.$message.error(res.msg)
            }
          })
      } else {
        Vue.prototype.goLoginView(true);
      }

    },
    /* 下载资料 */
    dowInfo(item) {
      const userInfo = getInfo()
      if (!userInfo) {
        Vue.prototype.goLoginView(false)
        return
      }
      if (this.IsPurchase) {
        if (item.uploadMaterial) {

          Vue.prototype.DownloadDoc(item.uploadMaterial, item.title)
        } else {
          this.$notify({
            title: '错误',
            message: '暂无资源',
            type: 'error',
            duration: 2000
          })
        }
      } else {
        this.$notify({
          title: '错误',
          message: '未购买，无法查看, 请先去购买',
          type: 'error',
          duration: 2000
        })
      }
    },
    openKowledge(item) {
      this.kowledgePointsVisible = true
      this.$nextTick(() => {
        this.$refs.kowledgePoints.getData(item.id)
      })
    },
    kowledgePointsClose() {
      this.kowledgePointsVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
.gouBack {
  color: #666666;
  font-size: 14px;
  cursor: pointer;
  width: 1220px;
  margin: 20px auto;
}

.bigBox {
  position: relative;
  width: 1220px;
  padding: 32px;
  background-color: #ffffff;
  border-radius: 8px;
  margin: auto;
  margin-bottom: 80px;

  .boxItem {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 104px;
    border-bottom: 1px solid #eeeeee;

    .contentItem {
      display: flex;
      align-items: center;
      position: relative;

      .seeBtn {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }

      .sourceImg {
        .imgItem {
          width: 40px;
          height: 40px;
          margin-right: 12px;
        }
      }

      .contentBox {
        .contentTitle {
          color: #333333;
          margin-bottom: 12px;
        }

        .contentTips {
          font-size: 12px;
          color: #a78888;
        }
      }
    }

    .btnItem {
      position: absolute;
      right: 32px;
      width: 88px;
      height: 30px;
      border: 1px solid #dddddd;
      border-radius: 4px;
      color: #666666;
      font-size: 14px;
      text-align: center;
      line-height: 30px;
      cursor: pointer;
    }

    .kowledge_Btn {
      width: 74px;
      height: 30px;
      border-radius: 4px;
      border: 1px solid #dddddd;
      color: #666666;
      font-size: 14px;
      text-align: center;
      line-height: 30px;
      margin-right: 20px;
      cursor: pointer;
    }

    .dowBtn {
      width: 60px;
      height: 30px;
      border: 1px solid #ff5e51;
      border-radius: 4px;
      color: #ff5e51;
      font-size: 14px;
      text-align: center;
      line-height: 30px;
      cursor: pointer;
    }
  }
}

.brace {
  width: 100%;
  height: 88px;
}

.buyBox {
  width: 100%;
  height: 88px;
  background-color: #ffffff;
  box-shadow: 0px -4px 8px 1px rgba(204, 204, 204, 0.20000000298023224);
  position: absolute;
  bottom: 270px;

  .priceBox {
    width: 1220px;
    height: 88px;
    margin: auto;
    display: flex;
    justify-content: end;

    .buyBtnBox {
      display: flex;
      align-items: center;

      .price {
        margin-right: 20px;

        .symbol {
          font-size: 18px;
          color: #ff5e51;
        }

        .num {
          font-size: 32px;
          color: #ff5e51;
        }
      }

      .buyBtn {
        width: 170px;
        height: 48px;
        background-color: #ff5e51;
        color: #ffffff;
        text-align: center;
        line-height: 48px;
        border-radius: 4px;
        cursor: pointer;
      }
    }
  }
}

.pack-box {
  position: relative;
  min-height: 80vh;
  height: 100%;

  .buyBox {
    bottom: 0px !important;
  }
}

.pack-box3 {
  .buyBox {
    bottom: -20px !important;
  }
}

/*.pack-box1 {
  .buyBox {
    bottom: 440px !important;
  }
} */
.kowledgePoints_wrap {
  padding-bottom: 20px;

  .determine_btn {
    width: 40%;
    height: 40px;
    margin: 0 auto;
    margin-top: 20px;
    background-color: #ff5e51;
    color: #ffffff;
    font-weight: 500;
    border-radius: 20px;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
  }
}
</style>
